import { format, isSameYear, isToday, isYesterday } from 'date-fns';
import { ru } from 'date-fns/locale';

export interface MessengerActivityDateLabelOpts {
  /** Время после запятой (списки, просмотры, мета). */
  includeTime?: boolean;
}

/**
 * Дата активности в стиле мессенджера: Сегодня / Вчера / dd.MM / dd.MM.yyyy (если не текущий год).
 */
export function formatMessengerActivityLabel(
  iso: string | null | undefined,
  opts?: MessengerActivityDateLabelOpts
): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return '';
  const includeTime = opts?.includeTime ?? false;
  const now = new Date();
  const hm = format(d, 'HH:mm', { locale: ru });

  if (includeTime) {
    if (isToday(d)) return `Сегодня, ${hm}`;
    if (isYesterday(d)) return `Вчера, ${hm}`;
    if (isSameYear(d, now)) return `${format(d, 'dd.MM')}, ${hm}`;
    return `${format(d, 'dd.MM.yyyy')}, ${hm}`;
  }

  if (isToday(d)) return 'Сегодня';
  if (isYesterday(d)) return 'Вчера';
  if (isSameYear(d, now)) return format(d, 'dd.MM');
  return format(d, 'dd.MM.yyyy');
}
